export default "/assets/images/real-time-air-alert.831fa4d1299cab1e.mp4";